import React, { useState } from 'react';
import { X, Mail, Send, Loader2, CheckCircle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const EmailResultsModal = ({ isOpen, onClose, profileData }) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/email/simulator-results`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          recipient_email: email,
          recipient_name: name,
          profile_name: profileData.profile.name,
          profile_emoji: profileData.profile.emoji,
          percentages: profileData.percentages,
          strengths: profileData.profile.strengths,
          watchouts: profileData.profile.watchOuts
        })
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.detail || 'Erro ao enviar email');
      }

      setSent(true);
      setTimeout(() => {
        onClose();
        setSent(false);
        setEmail('');
        setName('');
      }, 2500);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div 
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden animate-fade-in"
        onClick={(e) => e.stopPropagation()}
      >
        {sent ? (
          // Success State
          <div className="p-8 text-center">
            <div className="w-16 h-16 rounded-full bg-[#B5C4B1]/30 flex items-center justify-center mx-auto mb-4">
              <CheckCircle size={32} className="text-[#B5C4B1]" />
            </div>
            <h3 className="font-['Cormorant_Garamond'] text-2xl text-[#2C2C2C] mb-2">
              Email Enviado!
            </h3>
            <p className="text-[#8B7D6B]">
              Verifiquem a vossa caixa de entrada.
            </p>
          </div>
        ) : (
          <>
            {/* Header */}
            <div className="relative p-6 border-b border-[#E8E4E0]">
              <button
                onClick={onClose}
                className="absolute top-4 right-4 p-2 text-[#8B7D6B] hover:text-[#6B4E37] transition-colors"
                data-testid="close-email-modal"
              >
                <X size={20} />
              </button>
              
              <div className="w-12 h-12 rounded-xl bg-[#D4C4B0]/30 flex items-center justify-center mx-auto mb-3">
                <Mail size={24} className="text-[#6B4E37]" />
              </div>
              <h2 className="font-['Cormorant_Garamond'] text-2xl text-[#2C2C2C] text-center">
                Receber Resultados por Email
              </h2>
              <p className="text-sm text-[#8B7D6B] text-center mt-1">
                Enviamos o vosso perfil "{profileData?.profile?.name}" para guardarem
              </p>
            </div>

            {/* Content */}
            <div className="p-6">
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-[#6B4E37] mb-1">
                    Os vossos nomes
                  </label>
                  <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="w-full px-4 py-3 bg-[#FAF9F7] border border-[#E8E4E0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C4B5A0] text-[#2C2C2C]"
                    placeholder="Ex: Ana & João"
                    required
                    data-testid="email-name-input"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-[#6B4E37] mb-1">
                    Email
                  </label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full px-4 py-3 bg-[#FAF9F7] border border-[#E8E4E0] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#C4B5A0] text-[#2C2C2C]"
                    placeholder="email@exemplo.com"
                    required
                    data-testid="email-address-input"
                  />
                </div>

                {error && (
                  <p className="text-red-500 text-sm text-center">{error}</p>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-[#C4B5A0] text-white rounded-lg font-medium hover:bg-[#6B4E37] transition-colors disabled:opacity-50"
                  data-testid="send-email-btn"
                >
                  {loading ? (
                    <Loader2 className="w-5 h-5 animate-spin" />
                  ) : (
                    <>
                      <Send size={18} />
                      Enviar Resultados
                    </>
                  )}
                </button>
              </form>

              <p className="text-xs text-[#8B7D6B] text-center mt-4">
                Os vossos dados são usados apenas para este envio e não serão partilhados.
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EmailResultsModal;
